module.exports = __webpack_public_path__ + "img/sjef_logo.cac56b3d.png";